import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin } from '@react-oauth/google';
import { AlertCircle } from 'lucide-react';
import { BRAND } from '@/constants/brand';
import { useAuth } from '@/context/AuthContext';
import XperienceLogo from '@/components/ui/XperienceLogo';

export default function LoginScreen() {
  const { loginWithGoogle } = useAuth();
  const navigate = useNavigate();
  const [error, setError]   = useState('');

  const handleSuccess = async (credentialResponse) => {
    setError('');
    try {
      await loginWithGoogle(credentialResponse);
      navigate('/', { replace: true });
    } catch (err) {
      setError(err.message || 'No se pudo iniciar sesión.');
    }
  };

  const handleError = () => {
    setError('Google canceló el inicio de sesión. Intenta de nuevo.');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black relative overflow-hidden">
      {/* Grid decorativo */}
      <div
        className="absolute inset-0 opacity-[0.03]"
        style={{
          backgroundImage: `repeating-linear-gradient(45deg, ${BRAND.gold} 0, ${BRAND.gold} 1px, transparent 1px, transparent 40px)`,
        }}
      />
      {/* Glow */}
      <div
        className="absolute top-0 right-0 w-96 h-96 rounded-full blur-3xl opacity-10"
        style={{ background: BRAND.gold }}
      />

      <div className="relative z-10 w-full max-w-md px-8">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center justify-center w-16 h-16 mb-5">
            <XperienceLogo className="w-full h-full" />
          </div>
          {/* <h1 className="text-3xl font-bold text-white tracking-[0.25em] mb-1">XPERIENCE</h1> */}
          <div className="text-xs tracking-[0.3em] text-neutral-500">COTIZADOR</div>
        </div>

        {/* Card */}
        <div className="bg-neutral-900/50 backdrop-blur-xl border border-neutral-800 rounded-2xl p-7 shadow-2xl">
          <h2 className="text-white font-medium mb-1">Iniciar sesión</h2>
          <p className="text-neutral-500 text-sm mb-7">
            Usa tu cuenta <span className="text-neutral-300">@xperience.group</span>
          </p>

          {/* Google button — centrado y con tamaño completo */}
          <div className="flex justify-center mb-4">
            <GoogleLogin
              onSuccess={handleSuccess}
              onError={handleError}
              theme="filled_black"
              size="large"
              shape="rectangular"
              logo_alignment="left"
              text="continue_with"
              locale="es"
              width="320"
            />
          </div>

          {error && (
            <div className="flex items-center gap-2 p-3 bg-red-950/30 border border-red-900/50 rounded-lg text-red-400 text-sm">
              <AlertCircle className="w-4 h-4 shrink-0" />
              {error}
            </div>
          )}

          <div className="mt-6 pt-5 border-t border-neutral-800">
            <p className="text-xs text-neutral-500 text-center">
              Solo cuentas{' '}
              <span className="text-neutral-400 font-mono">@xperience.group</span>{' '}
              tienen acceso.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}